import React from 'react';
 
const FirebaseContext = React.createContext<any | null>(null);

export default FirebaseContext;